import { Provider } from '@angular/core';
import { GOOGLE_MAPS_CONFIG_TOKEN, GoogleMapsConfig } from './google-maps.service';

export function provideGoogleMapsConfig(config: GoogleMapsConfig): Provider {
    return {
        provide: GOOGLE_MAPS_CONFIG_TOKEN,
        useValue: config,
    };
}
